import { Component, forwardRef } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import { ComboIdDescricao } from '../../../core/combo-publico-alvo';
import { PublicoAlvoService } from '../../../services/publico-alvo/publico-alvo.service';
import { ComboIdDescricaoComponent } from '../combo-id-descricao/combo-id-descricao.component';

@Component({
  selector: 'combo-publico-alvo',
  templateUrl: './combo-publico-alvo.component.html',
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm },
    { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }
  ]
})
export class ComboPublicoAlvoComponent extends ComboIdDescricaoComponent<ComboIdDescricao> {
  
  constructor(private publicoAlvoService: PublicoAlvoService) {
    super();
  }

  protected getDados() {
    return this.publicoAlvoService.getAllCombo();
  }
}
